var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".allstate-cls-1{fill:#003084;}.allstate-cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Allstate"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "allstate-cls-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    className: "allstate-cls-2",
    d: "M15,6.56l-9.39,15H8.81l2.4-3.86h5.38v3.86h3v-15H15M16.58,15h-3.7c.23-.36,3.7-6,3.7-6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllstate);
export default __webpack_public_path__ + "static/media/Allstate.2453693f9041ecba4ccc10f4d4ede196.svg";
export { ForwardRef as ReactComponent };